module.exports = __webpack_public_path__ + "img/Hatchback_Front_Side_Left_Transparent.34cd6f14.svg";